import { PhoneNumberUtil, PhoneNumberType, PhoneNumberFormat } from 'google-libphonenumber';

export function toUTCDateString(dt: string) {
  let date = new Date(dt)
  const diff = date.getTimezoneOffset();
  const gmtHoras = diff / 60;
  date.setHours(date.getHours() + gmtHoras)
  return date.toISOString().split('T')[0];
}
export function toUTCDate(dt: string) {
  let date = new Date(dt)
  const diff = date.getTimezoneOffset();
  const gmtHoras = diff / 60;
  date.setHours(date.getHours() + gmtHoras)
  return date
}

export function toUTC(appointmentdate: string) {
  let dateObject = new Date(appointmentdate);
  dateObject = new Date(dateObject.getTime() + dateObject.getTimezoneOffset() * 60000)
  return dateObject.toISOString().split('T')[0];
}

export function createServerDate() {
  let storedSettings = localStorage.getItem("settings");
  let offset = -3; // Valor predeterminado en caso de que no haya un ajuste de GMT almacenado.
  try {
    if (storedSettings) {
      const storedSettingsJson = JSON.parse(storedSettings);
      if (storedSettingsJson.hasOwnProperty("gmtOffset")) {
        offset = storedSettingsJson.gmtOffset;
      }
    }
  } catch (error) {
    console.error("Error al analizar el gmt en la configuración almacenada:");
  }
  // Paso 1: Obtener la hora actual en el huso horario local
  const horaActualLocal = new Date();

  // Paso 2: Obtener el desplazamiento horario actual en minutos (positivo o negativo)
  const desplazamientoHorarioActual = horaActualLocal.getTimezoneOffset();

  // Paso 3: Convertir el desplazamiento horario a milisegundos
  const desplazamientoHorarioMilisegundos = desplazamientoHorarioActual * 60 * 1000;

  // Paso 4: Calcular el desplazamiento horario para GMT -3 en milisegundos
  const desplazamientoGMTmenos3Milisegundos = (offset * 60 * 60 * 1000);

  // Paso 5: Sumar el desplazamiento horario para GMT -3 a la hora actual en el huso horario local
  const horaActualGMTmenos3 = new Date(horaActualLocal.getTime() + desplazamientoHorarioMilisegundos + desplazamientoGMTmenos3Milisegundos);

  return horaActualGMTmenos3;
}
export function convertStringToHoursAndMinutes(date: string) {
  const parts = date.split("T")[1].split(":");
  const hours = Number.parseInt(parts[0], 10);
  const minutes = Number.parseInt(parts[1], 10);
  return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
}
export function convertStringtoDate(date: string) {
  const day = date.split("T")[0];
  return day
}

export function formateDateStringISO8601(date: string) {
  const characters = date.split("T")[0].split("-");
  if (characters.length === 3) {
    const [year, month, day] = characters;
    return `${day}-${month}-${year}`;
  } else {
    return date.split("T")[0];
  }
}
export function fromDateToString(date: Date) {
  if (date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // El mes es de 0 a 11, así que sumamos 1 y lo formateamos
    const day = String(date.getDate()).padStart(2, '0');
    // Crea el string de fecha en el formato deseado (por ejemplo, "AAAA-MM-DD")
    const dateString = `${year}-${month}-${day}`;
    return dateString;
  }
  return "";
}

function getKeyByValue(value: number, enumValues: any): string | null {
  const entries = Object.entries(enumValues);
  const foundEntry = entries.find(([_, val]) => val === value);
  return foundEntry ? foundEntry[0] : null;
}

// Función para obtener la cadena de texto del estado basado en el valor numérico
export function getStringEnumValueByIdEnum(id: number, enumValues: any): string {
  const stateKey = getKeyByValue(id, enumValues);
  return stateKey ?? 'Error'; // stateKey será la cadena de texto del enum si se encuentra, undefined en caso contrario
}

export type Cuit = `${string}-${string}-${string}`
export function handleCUITValidation(cuit: Cuit): boolean {
  // Verificar el formato del CUIT
  const cuitRegex = /^\d{2}-\d{8}-\d$/;
  if (!cuitRegex.test(cuit)) {
    return false;
  }

  const [prefix, document, verifiedDigit] = cuit.split("-")

  // Calcular el dígito verificador esperado
  const cuitWithoutDV = `${prefix}${document}`
  const expectedDV = calculateCUITDV(cuitWithoutDV)

  // Verificar si el dígito verificador ingresado coincide con el esperado
  return verifiedDigit === expectedDV.toString()
}

function calculateCUITDV(cuitWithoutDV: string): number {
  const coefficients = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let total = 0;
  for (let i = 0; i < cuitWithoutDV.length; i++) {
    total += Number.parseInt(cuitWithoutDV.charAt(i)) * coefficients[i];
  }
  const remainder = total % 11;
  const dv = remainder === 0 ? 0 : remainder === 1 ? 9 : 11 - remainder;
  return dv;
}


export function isNullOrEmpty(value: string | number | null | undefined): boolean {
  if (typeof value === 'number') {
    return value === null || value === undefined;
  }
  return value === null || value === undefined || value.trim() === "";
}

export interface ValidationResponse {
  errorMessage: string | null;
  isValid(): boolean;
}

export function validateInternationalCellphone(number: string): ValidationResponse {
  const phoneUtil = PhoneNumberUtil.getInstance();

  try {
    const parsed = phoneUtil.parse(number);
    const isValid = phoneUtil.isValidNumber(parsed);
    const regionCode = phoneUtil.getRegionCodeForNumber(parsed);
    const nationalNumber = parsed.getNationalNumber().toString();

    let exampleFormatted = '';
    if (regionCode === 'AR') {
      exampleFormatted = '+54 2231234567';
    } else {
      const example = phoneUtil.getExampleNumberForType(regionCode, PhoneNumberType.MOBILE);
      exampleFormatted = phoneUtil.format(example, PhoneNumberFormat.INTERNATIONAL);
    }

    if (!isValid) {
      return {
        errorMessage: `El número no es válido para ${regionCode}. Asegurate de que tenga el formato correcto. Ejemplo: ${exampleFormatted}`,
        isValid() {
          return false;
        }
      };
    }

    if (regionCode === 'AR') {
      if (/^\+54\s*0/.test(number)) {
        return {
          errorMessage: 'No se debe incluir el 0 después del código de país.',
          isValid() {
            return false;
          }
        };
      }

      if (/^\+54\s*15/.test(number)) {
        return {
          errorMessage: 'No se debe incluir el 15 después del código de país.',
          isValid() {
            return false;
          }
        };
      }
      if (nationalNumber.length !== 10) {
        return {
          errorMessage: `El número debe tener 10 dígitos: código de área sin 0 + número sin 15. Ejemplo: ${exampleFormatted}`,
          isValid() {
            return false;
          }
        };
      }
    }

    return {
      errorMessage: null,
      isValid() {
        return true;
      }
    };
  } catch (e) {
    return {
      errorMessage: 'Formato inválido. Asegurate de escribir el número en formato internacional (ej: +54 2231234567).',
      isValid() {
        return false;
      }
    };
  }
}